/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import classes from "./style";

const BlocTroimdots: FC<{}> = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={classes.homeBloc}>
      <Typography variant="subtitle2" color="primary">
        Caladre en 3 mots
      </Typography>
      <Grid container>
        <Grid item xs={12} md={4}>
          <Box>
            <ForumOutlinedIcon />
          </Box>
          <Typography variant="h5" color="primary">
            Échange
          </Typography>
          <Typography variant="body1" color="primary">
            Une communauté
            <br />
            prête à échanger
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box>
            <HttpsOutlinedIcon />
          </Box>
          <Typography variant="h5" color="primary">
            Sécurité
          </Typography>
          <Typography variant="body1" color="primary">
            Messagerie et
            <br />
            profils sécurisés
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box>
            <GroupsOutlinedIcon />
          </Box>
          <Typography variant="h5" color="primary">
            Communauté
          </Typography>
          <Typography variant="body1" color="primary">
            Un groupe prêt à
            <br />
            partager ses passions
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BlocTroimdots;
